import {useAtomValue} from "jotai";
import {WorkloadScanAtom} from "../2-scanning/WorkloadScanAtom.tsx";
import {ActiveWorkloadsSection} from "./sections/ActiveWorkloadsSection.tsx";
import {RecommendationsSection} from "./sections/RecommendationsSection.tsx";
import type {Workload} from "../3-workload-analysis/model/Workload.ts";
import type {WorkloadInput} from "../3-workload-analysis/model/WorkloadInput.ts";

/**
 * Main widget displaying customer analysis results
 */
export function CustomerResultsWidget() {
    const scanResult = useAtomValue(WorkloadScanAtom)

    if (!scanResult) {
        return <div>No scan results available. Please complete the scanning step first.</div>
    }

    const {scoringResult, workloadInputs} = scanResult

    if (workloadInputs.length === 0) {
        return <div>No workload data available.</div>
    }

    // Create a map of workloadInputs by project for easy lookup
    const workloadInputMap = new Map<string, WorkloadInput>()
    workloadInputs.forEach(input => {
        const key = `${input.projectId.groupName}/${input.projectId.projectName}`
        workloadInputMap.set(key, input)
    })

    // Function to get the correct workloadInput for a given workload
    const getWorkloadInput = (workload: Workload): WorkloadInput | undefined => {
        const key = `${workload.versionId.groupName}/${workload.versionId.projectName}`
        return workloadInputMap.get(key)
    }

    return (
        <div>
            <h2>Migration Analysis Results</h2>
            <ActiveWorkloadsSection
                workloadScores={scoringResult.workloadScores}
                getWorkloadInput={getWorkloadInput}
            />
            <RecommendationsSection
                workloadScores={scoringResult.workloadScores}
                getWorkloadInput={getWorkloadInput}
            />
        </div>
    )
}
